  

/**
 * The base border styles for the Vision UI Dashboard  Material.
 * You can add new border width, border color or border radius using this file.
 * You can customized the borders value for the entire Vision UI Dashboard  Material using thie file.
 */

// Vision UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";

// Vision UI Dashboard React Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderCol } = colors;

export default {
  borderColor: {
    grey: { borderCol },
    white: "rgba(226, 232, 240, 0.6)",
  },

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(2),      // 2px → 0.125rem
    sm: pxToRem(4),      // 4px → 0.25rem
    md: pxToRem(8),      // 8px → 0.5rem
    button: pxToRem(12), // 12px → 0.75rem
    lg: pxToRem(15),     // 15px → 0.9375rem
    xl: pxToRem(20),     // 20px → 1.25rem
    xxl: pxToRem(24),    // 24px → 1.5rem
    form: pxToRem(24),   // 24px → 1.5rem
    section: pxToRem(160) // 160px → 10rem
},
};
